import { AccelFile, Entity, SchoolApplication } from '../..';
import { observable, action } from 'mobx';
import moment, { type Moment } from 'moment';

export class VkGroup extends Entity {
    constructor(g?: Partial<VkGroup>) {
        super(g);
        if (g) this.update(g);
    }

    externalId: string;
    externalName: string;

    @observable name: string;
    @observable keyPhrase: string;
    @observable createdDate: Moment;
    @observable updatedDate: Moment | null;
    /** instructions html template */
    @observable description: string;

    @observable schoolApp: SchoolApplication;
    @observable image: AccelFile | null;

    @observable usersCount: number;

    @action update(g: Partial<VkGroup>, allowUndefined = false) {
        super.update(g, allowUndefined);
    }

    static fromJson(json: any): VkGroup {
        return new VkGroup({
            id: json.id,
            name: json.name,
            keyPhrase: json.keyPhrase,
            externalId: json.externalId,
            externalName: json.externalName,
            description: json.description,
            softDeleted: json.softDeleted,
            softDeletedDate: json.softDeletedDate ? moment(json.softDeletedDate) : undefined,
            createdDate: json.createdDate ? moment(json.createdDate) : undefined,
            updatedDate: json.updatedDate ? moment(json.updatedDate) : null,
            schoolApp: json.schoolLink ? SchoolApplication.fromJson(json.schoolLink) : undefined,
            image: json.image ? AccelFile.fromJson(json.image) : null,
            usersCount: json.usersCount ?? 0
        });
    }
}

export default VkGroup;
